export class ResetOrganisationProjectsList {
  public static readonly type =
    '[Organisation/Projects/List] ResetOrganisationProjectsList';
}
